import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

class History {
  static _history = null;
  static save(history) {
    this._history = history;
  }
  static push(...args) {
    this._history.push(...args);
  }
  static replace(...args) {
    this._history.replace(...args);
  }
}

History.save(history);

export default History;
